import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BulkEditProgressOverlayModule } from "@app/components/bulk-edit-progress-overlay/bulk-edit-progress-overlay.module";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { BulkOperationProgressDialogComponent } from "./bulk-operation-progress-dialog.component";

@NgModule({
	declarations: [BulkOperationProgressDialogComponent],
	imports: [CommonModule, MaterialModule, TranslateModule, BulkEditProgressOverlayModule],
	exports: [BulkOperationProgressDialogComponent],
})
export class BulkOperationProgressDialogModule {}
